import { render, staticRenderFns } from "./CustomPhone.vue?vue&type=template&id=f28ee8ac"
import script from "./CustomPhone.vue?vue&type=script&lang=js"
export * from "./CustomPhone.vue?vue&type=script&lang=js"
import style0 from "./CustomPhone.vue?vue&type=style&index=0&id=f28ee8ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports